var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "products__item",
      class: {
        "products__item--special": _vm.product.special,
        "products__item--limited": _vm.stock > 0,
      },
    },
    [
      _c(
        "button",
        {
          ref: "message",
          staticClass: "products__item-message",
          class: { "products__item-message--added": _vm.addedToCart },
          on: { click: _vm.onCloseMessage },
        },
        [
          _c("span", {
            staticClass: "products__item-message-text",
            domProps: {
              innerHTML: _vm._s(_vm.$t("shoplist.product.successCart")),
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "products__item-image",
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.onClick.apply(null, arguments)
            },
          },
        },
        [
          _c("img", {
            staticClass: "products__item-image-element",
            attrs: {
              src:
                (_vm.product.special && _vm.product.imageSpecial) ||
                _vm.product.image,
              alt: "Product Image",
              loading: "lazy",
            },
          }),
        ]
      ),
      _vm._v(" "),
      _vm.product.isNewFlavour
        ? _c("div", {
            staticClass: "products__item-new",
            domProps: {
              innerHTML: _vm._s(_vm.$t("shoplist.product.newFlavour")),
            },
          })
        : _vm.product.isPlanted
        ? _c("div", { staticClass: "products__item-planted" }, [
            _c("img", {
              staticClass: "products__item-planted-label",
              attrs: {
                src: _vm.productLabelPath("planted"),
                alt: "planted label",
              },
            }),
          ])
        : _vm.product.isLimited
        ? _c("div", {
            staticClass: "products__item-limited",
            domProps: {
              innerHTML: _vm._s(_vm.$t("shoplist.product.limitedEdition")),
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "products__item-container" }, [
        _c(
          "a",
          {
            staticClass: "products__item-title",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.onClick.apply(null, arguments)
              },
            },
          },
          [
            _c("span", {
              staticClass: "products__item-title-name",
              domProps: { innerHTML: _vm._s(_vm.product.name) },
            }),
            _vm._v(" "),
            _vm.product.isVegetarian || _vm.product.isVegan
              ? _c("SVGLabelLeaf", {
                  staticClass: "products__item-title-label",
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.product.isVegan
              ? _c("SVGLabelLeaf", {
                  staticClass: "products__item-title-label",
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", {
          staticClass: "products__item-desc",
          domProps: {
            innerHTML: _vm._s(
              _vm.product.shortDescription || _vm.product.description
            ),
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "products__item-price" },
          [
            _vm.originalPrice
              ? _c("strike", {
                  staticClass: "products__item-price-old",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$options.filters.madpricecent(_vm.originalPrice)
                    ),
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("span", {
              staticClass: "products__item-price-current",
              domProps: {
                innerHTML: _vm._s(_vm.$options.filters.madpricecent(_vm.price)),
              },
            }),
            _vm._v(" "),
            _vm.product.unit
              ? _c("span", {
                  staticClass: "products__item-price-unit",
                  domProps: { innerHTML: _vm._s(_vm.product.unit) },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _vm.hasBasket
          ? _c(
              "div",
              { staticClass: "products__item-cart" },
              [
                !_vm.product.isEditable
                  ? _c("QuantityCounter", {
                      class: {
                        "products__item-quantity--soldout": !_vm.isAvailable,
                      },
                      attrs: {
                        quantity: _vm.quantity,
                        "base-class": "products__item-quantity",
                        locked: !_vm.isAvailable,
                      },
                      on: {
                        sub: function ($event) {
                          return _vm.onSub()
                        },
                        add: function ($event) {
                          return _vm.onAdd()
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("Button", {
                  staticClass: "products__item-cart-button",
                  class: {
                    "products__item-cart-button--soldout": !_vm.isAvailable,
                    "btn--no-animation": !_vm.isAvailable || _vm.locked,
                  },
                  attrs: {
                    level: "primary",
                    type: "button",
                    text: _vm.isAvailable
                      ? _vm.$t("shoplist.product.add")
                      : _vm.$t("shoplist.product.soldOut"),
                    disabled: _vm.locked || !_vm.isAvailable,
                    variants: ["small"],
                  },
                  on: {
                    click: function ($event) {
                      return _vm.onCart()
                    },
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }